// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* ------------------------------------------------------------------------------------------ */
/* DSM -> Based on the "Color Tokens" view -------------------------------------------------- */
/* ------------------------------------------------------------------------------------------ */

const colors: Styleguide["colors"] = {
    primary: {
        main: "#0051ab", // DSM -> Primary/main
        contrast: "#ffffff", // DSM -> None, look at primary button text color
        light: "#7691ca", // DSM -> Primary/light
        dark: "#243d6f", // DSM -> Primary/dark
    },
    secondary: {
        main: "#cc4b0e", // DSM -> Secondary/main
        contrast: "#ffffff", // DSM -> None, look at secondary button text color
        light: "#f06400", // DSM -> Secondary/light
        lightest: "#f8dfbc",
        dark: "#8d3105", // DSM -> Secondary/dark
    },
    tertiary: {
        main: "#758dbd", // DSM -> Tertiary/main
        contrast: "#ffffff", // DSM -> None, look at tertiary button text color
        light: "#9fb8ec", // DSM -> Tertiary/light
        dark: "#566fa3", // DSM -> Tertiary/dark
    },
    common: {
        border: "#e6e6e6", //     DSM -> None, look at input border color or layout borders
        borderDark: "#9ca5b2", // DSM -> Grey/main
        accent: "#f3F5F7", // DSM -> Grey/light
        accentContrast: "#212121", // DSM -> Text/main
        accentContrastLight: "#9ca5b2", // DSM -> Grey/main
        background: "#ffffff", // DSM -> None
        backgroundContrast: "#212121", // DSM -> Text/main
        disabled: "#dbe0e6", // DSM -> Grey/light
        disabledDark: "#e6e6e6", // DSM -> Grey/mid
    },
    text: {
        main: "#212121", // DSM -> Text/main
        accent: "#36404c", // DSM -> Text/accent
        disabled: "#36404c", // DSM -> Grey/main
        link: "#cc4b0e", // DSM -> Primary/main
        linkHover: "#243D6F", // DSM -> Primary/dark
        linkAlt: "#212121", // DSM -> Text/main
        linkAltHover: "#0051ab", // DSM -> Primary/main
        input: "#212121", // DSM -> Text/main
    },
    success: {
        main: "#014601", // DSM -> Alerts/Contrast/Success
        contrast: "#ffffff", // DSM -> None, look at text color for the Alerts/Contrast/Success token
        light: "#72A713", // DSM -> Alerts/Light/Success
    },
    warning: {
        main: "#ffbb38", // DSM -> Alerts/Contrast/Warning
        contrast: "#ffffff", // DSM -> None, look at text color for the Alerts/Contrast/Warning token
        light: "#ffebc6", // DSM -> Alerts/Light/Warning
    },
    danger: {
        main: "#D30303", // DSM -> Alerts/Contrast/Error
        contrast: "#ffffff", // DSM -> None, look at text color for the Alerts/Contrast/Danger token
        light: "#ffc3d2", // DSM -> Alerts/Light/Error
    },
    info: {
        main: "#1d8ed5", // DSM -> Alerts/Contrast/Info
        contrast: "#ffffff", // DSM -> None, look at text color for the Alerts/Contrast/Info token
        light: "#c9edff", // DSM -> Alerts/Light/Info
    },
    neutral: {
        main: "#666666", // DSM -> None
        contrast: "#ffffff", // DSM -> None
        light: "#e0e0e0", // DSM -> None
    },
    invert: {
        main: "#ffffff", // None
        contrast: "#0f0f0f", // None
        dark: "#ececec", // None
    },
    placeholder: {
        main: "#666666", // DSM -> None, look at header search field text color
        disabled: "#36404c", // DSM -> Text/disabled
    },
    button: {
        disabled: {
            // These colors should be different than the field disabled styles (common.disabled / text.disabled)
            main: "#e6e6e6", // DSM -> None
            contrast: "#939393", // DSM -> None
        },
    },
    header: {
        main: "#ffffff", // None, look at header background color
        contrast: "#0F0F0F", // Text Color -> Main
        hover: "#f3F5F7", // Primary -> Dark
        accent: "#ffffff", // Primary -> Main
        accentHover: "#f3F5F7", // Primary -> Dark
        accentContrast: "#ffffff", // None, should match "primary.contrast"
    },
    // Store Removed - menu
    footer: {
        main: "#243d6f", // DSM -> Grey/light
        contrast: "#0051ab", // DSM -> Text/main
        alt: "#212121", // DSM -> Grey/mid
        altContrast: "#ffffff", // DSM -> Text/accent
    },
    swatch: {
        main: "#CCCCCC", // Black & White -> Border
        contrast: "#212121", // None, should match "primary.contrast"
        hover: "#9ca5b2", // Gray Shades -> Main
        selected: "#B6E8C4", // Primary -> Main
        selectedHover: "#B6E8C4", // Primary -> Dark
    },
};

export default colors;
